import React from 'react';
import './Booking_ticket.css';
import Ticket from '../../Aseets/Img/ticket icon.svg';

const Ticket_Card = (props) => {
  return (
    <div className='ticket_card'>
        <div className='ticket_card_div1'>
            <img className='ticket_card_icon' src={Ticket}></img>
            <h3 className='ticket_card_text1'>{props.title}</h3>
            <h3 className='ticket_card_text1'>{props.price}</h3>
            <div className='ticket_card_line'></div>
            <div className='ticket_card_div2'>
                <h4 className='ticket_card_text2'>{props.text1}</h4>
                <h4 className='ticket_card_text2'>{props.text2}</h4>
                <h4 className='ticket_card_text2'>{props.text3}</h4>
                 <h4 className='ticket_card_text2'>{props.text4}</h4>
            </div>
        </div>
    </div>
  );
};

export default Ticket_Card;